/**
 * Swift's `min(100, max(0, x))` on Doubles. Swift's generic max/min return the first
 * argument unless the comparison holds, so NaN clamps to 0.
 */
export function clampPercent(value: number): number {
  const floored = value >= 0 ? value : 0;
  return floored < 100 ? floored : 100;
}
